import { render, staticRenderFns } from "./SubscriptionAlert.vue?vue&type=template&id=0e6a4006&scoped=true"
import script from "./SubscriptionAlert.vue?vue&type=script&lang=js"
export * from "./SubscriptionAlert.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionAlert.vue?vue&type=style&index=0&id=0e6a4006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a4006",
  null
  
)

export default component.exports